<template>
	<div>
		<div class="mengCeng">
			<img src="@/assets/images/mencheng.png" class="w-100 mengCengtu" alt="">
		</div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>产品详情</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row row-cols-lg-2 row-cols-md-2 row-cols-1">
		            <div class="col">
		                <div class="project-details-img-wrap">
		                    <div class="project-details-img mb-6" v-for="(item,index) in imgInfo" :key="index">
		                        <img :src="item | imgfilter" alt="Project Image">
		                    </div>
		                </div>
		            </div>
		            <div class="col sidebar-active">
		                <div class="project-wrapper-sticky">
		                    <div class="project-details-content mb-5 mb-md-8">
		                        <h5 style="color: #4A4A4A;">{{productInfo.name}}</h5>
		                        <div class="project-details-list-content"> 
		                            <span class="tag" v-for="(tag,tai) in productInfo.tags" :key="tai">{{tag}}</span>
		                        </div>
								<div class="d-flex" style="margin-top: 30px;justify-content: space-between;">
									<div class="d-flex" style="align-items: center;">
										<Icon class="c-00" v-if="productInfo.like_flag" style="cursor: pointer;" size="30" color="#ff495e" type="ios-heart" @click="collect(productInfo)" />
										<Icon class="c-00" v-else style="cursor: pointer;" size="30" type="ios-heart-outline" @click="collect(productInfo)" />
										<span style="margin-left: 10px;">{{productInfo.like_count}}</span>
									</div> 
									<div class="d-flex" style="align-items: center;">
										<Icon class="c-00" v-if="productInfo.save_flag" style="cursor: pointer;" size="30" color='#f8dd66' type="ios-star" @click="collectsave(productInfo)" />
										<Icon class="c-00" v-else style="cursor: pointer;" size="30" type="ios-star-outline" @click="collectsave(productInfo)" />
										<span style="margin-left: 10px;">{{productInfo.save_count}}</span>
									</div> 
									<div class="d-flex" style="align-items: center;">
										<Icon size="30" type="ios-chatboxes-outline" />
										<span style="margin-left: 10px;">{{productCommentList.length}}</span>
									</div> 
								</div>
		                    </div>
		                    <div class="project-details-info modify">
								<h5 style="color: #4A4A4A;" class="title">所属商家</h5>
								<div style="margin-top: 20px;margin-left: 30px;display: flex;align-items: center;">
									<div @click="toMerchant(merchantInfo)" style="cursor: pointer;margin-right: 10px;">{{merchantInfo.name}}</div>
									<Icon type="ios-arrow-forward" />
								</div>
		                    </div>
		                    <div class="social-icon-style mb-5">
		                        <h5 class="title" style="margin-bottom: 20px;color: #4A4A4A;">产品评论({{productCommentList.length}})</h5>
								<div>
									<div class="pd-3" style="display: flex;">
										<Input type="textarea" v-model="commentText" placeholder="说点什么吧..." @on-enter="ProductCommentSave" />
										<Button style="margin-left: 10px;" type="primary" shape="circle" @click="ProductCommentSave">发送</Button>
									</div>
									<Scroll height='600'>
									<div class="comment" v-for="(res, index) in productCommentList" :key="res.id">
										<div class="left">
											<img v-if="res.avatar" :src="res.avatar" style="width: 54px;height: 54px;"></img>
											<img v-else src="@/assets/images/logo/logo.png" style="width: 54px;height: 54px;"></img>
										</div>
										<div class="right">
											<div class="top">
												<div>
													<div>{{ res.nickname }}</div>
													<div class="time">{{ res.add_time }}</div>
												</div>
												<div class="like" :class="{ highlight: res.like_flag }">
													<Icon style="cursor: pointer;" size="30" @click="clickLike(res)" :color="res.like_flag?'#009C44':''" type="md-thumbs-up" />
													<div class="num">{{ res.like_count }}</div>
												</div>
											</div>
											<div class="content" @click="replyPid(res)">{{ res.comment }}</div>
											<div class="reply-box">
												<div class="item" v-for="(item, index) in res.children" :key="item.index">
													<div class="left">
														<img :src="item.avatar | imgfilter"></img>
													</div>
													<div class="right">
														<div style="line-height: 40rpx;">{{ item.nickname }}</div>
														<div>{{ item.comment }}</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									</Scroll>
								</div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
		<div class="inapp">
			<span @click="getHref">在APP中打开</span>
		</div>
	</div>
</template>

<script>
	import forbiddenArray from "@/static/js/badWord.js";
import { getCookies } from '@/libs/util'
import { 
	getProductInfo,
	getProductCommentList,
	ProductLikeAdd,
	ProductLikeDel,
	ProductCommentSave,
	commentProductLikeAdd,
	commentProductLikeDel,
	CollectAdd,
	CollectDel
} from "@/api"
export default {
   data() {
		return { 
			userInfo: {},
			pid: 0,
			commentText: '',
			bgImg: require('@/static/images/banner/banner-3.jpg'),
			imgInfo: [],
			productInfo: {},
			merchantInfo: {},
			
			productCommentList: [],
			cateList: [{
				id: 0,
				name: '案例',
			},
			{
				id: 1,
				name: '展厅',
			},
			{
				id: 2,
				name: '产品'
			}],
			
			dataList: [],
			cateIndex: 0,
			
			total: 0,
			currentPage: 1,
			timer: null
		}
	},
	created() {
		this.getProductInfo()
		this.getProductCommentList()
	},
	mounted() {
		this.userInfo = this.$store.state.app.userInfo
	},
	computed: {
		isLogin() {
		  return getCookies("webtoken");
		},
	},
	methods:{
		getHref() {
			let that = this
			var ua = navigator.userAgent.toLowerCase();
			var isWeixin = ua.indexOf('micromessenger') != -1;
			let mengCeng = document.querySelector('.mengCeng');
			let mengCengtu = document.querySelector('.mengCengtu');
			if (isWeixin) {
				mengCeng.style.height = "100vh";
				mengCengtu.style.display = "block";
			    return;
			}
			let params = 'pid='+ this.$route.params.id + '&type='+2
		    that.opening = true
		    //android终端
		    let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
		    //ios终端
		    let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				console.log('ios')
			    window.location = "zhuke://" + params
			    that.timer = setTimeout(function () { //  未安装的情况
			    that.opening = false
			    //  跳转app store
			    let r = confirm("未安装APP? 是否去App store查看")
			    if (r) {
					window.location = 'https://apps.apple.com/cn/app/%E7%AD%91%E5%A3%B3/id1624314273'
			    }
			  }, 5000);
			  mengCeng.style.height = "0vh";
			  mengCengtu.style.display = "none";
			} else {
				let ifr = document.createElement('iframe');
				ifr.src ="zhuke://" + params;
				ifr.style.display = 'none';
				document.body.appendChild(ifr);
				that.timer = window.setTimeout(function () {  //  未安装的情况
				    that.opening = false
				    document.body.removeChild(ifr);
				    //  提示下载
				    let r = confirm("未安装APP? 是否下载")
				    if (r) {
					   window.location = 'https://www.zikkkk.com/downloadApp/筑壳.apk'
				    }
				}, 5000)
				mengCeng.style.height = "0vh";
				mengCengtu.style.display = "none";
			}
		},
		
		toMerchant(data) {
			let routeUrl3 = this.$router.resolve({
				path: '/merchantDetail/'+data.zk_id,
			  })
			  window.open(routeUrl3.href, '_blank')
		},
		
		// 收藏
		collectsave(item) {
			let that = this
			if(!this.isLogin) {
				alert('请登录后操作')
				return false
			}
			if(item.save_flag){
				let param={
					type: 1,
					pr_id:item.id
				}
				CollectDel(param).then((res)=>{
					if(res.status==200){
						that.$message.success("取消收藏")
						item.save_flag = 0
						item.save_count--
					}
				})
			}else{
				let param={
					type: 1,
					pr_id:item.id
				}
				CollectAdd(param).then((res)=>{
					if(res.status==200){
						that.$message.success("收藏成功")
						item.save_flag = 1
						item.save_count++
					}
				})
			}
		},
		
		clickCate(id) {
			this.cateIndex = id
			switch (id){
				case 1:
					this.getMerchantShowList()
					break;
				case 2:
					this.getMerchantProductList()
					break;	
				default:
					this.getMerchantProjectList()
					break;
			}
		},
		
		// 评论点赞
		clickLike(item) {
			if(!this.isLogin) {
				alert('请登录后操作')
				return false
			}
			let that = this
			if(item.like_flag){
				let param={
					comment_id: item.id
				}
				commentProductLikeDel(param).then((res)=>{
					if(res.status==200){
						that.$message.success(res.msg)
						item.like_flag = 0
						item.like_count--
					}
				})
			}else{
				let param={
					comment_id: item.id
				}
				commentProductLikeAdd(param).then((res)=>{
					if(res.status==200){
						that.$message.success('点赞成功')
						item.like_flag = 1
						item.like_count++
					}
				})
			}
		},
		
		// 页数跳转
		handleCurrentChange(val) {
			this.currentPage = val
			this.getMerchantList()
			document.documentElement .scrollTop= 0
		},
		
		// 获取商家详情
		async getProductInfo() {
		  const res = await getProductInfo({
			  product_id: this.$route.params.id
		  })
		 let data = res.data.info || {}
		 this.imgInfo = data.slider_image
		 
		 if(data.tags) data.tags = data.tags.split(',') || []
		 this.productInfo = data
		 
		 this.merchantInfo = data.merchant_info
		 
		 // $('.sidebar-active').stickySidebar({
		 //     topSpacing: 80,
		 //     bottomSpacing: 30,
		 //     minWidth: 767,
		 // });
		},
		
		// 产品评论
		async ProductCommentSave() {
			let that = this
			this.forbiddenArray=forbiddenArray.forbiddenArray;
			if(!this.isLogin) {
				alert('请登录后操作')
				return false
			}
			if(this.commentText.trim() == '') {
				alert('请输入评论内容')
				return false
			}
			var re = '';
			 for(var i=0;i<forbiddenArray.length;i++){
				  if(i==forbiddenArray.length-1)
					 re+=forbiddenArray[i];
				 else
				   re+=forbiddenArray[i]+"|";
			 }
			 //定义正则表示式对象
			 //利用RegExp可以动态生成正则表示式
			 var pattern = new RegExp(re,"gi");
			 let showInput=this.commentText.replace(pattern,"*")
			 if(pattern.test(this.commentText)){
				 alert('含有敏感词')
				 return false;
			 }else{
			    await ProductCommentSave({
				  product_id: this.$route.params.id,
				  nickname: that.userInfo.nickname,
				  avatar: that.userInfo.avatar,
				  pid: that.pid,
				  comment: that.commentText
			   }).then(res => {
				  this.getProductCommentList()
				  that.commentText = ''
				  that.pid = 0
			   }).catch(err => {
				  
			   })
			 }
		},
		
		// 获取产品评论
		async getProductCommentList() {
		  const res = await getProductCommentList({
			  product_id: this.$route.params.id
		  })
		  let data = res.data.list || []
		  this.productCommentList = data
		},
		
		collect(item){
			if(!this.isLogin) {
				alert('请登录后操作')
				return false
			}
			if(item.like_flag == 0){
				ProductLikeAdd({
					pro_id:item.id
				}).then((res)=>{
					if(res.status==200){
						item.like_flag= 1
						item.like_count++
					}
				})
			}else{
				ProductLikeDel({
					pro_id:item.id
				}).then((res)=>{
					if(res.status==200){
						item.like_flag= 0
						item.like_count--
					}
				})
			}
		},
		
	}
}
</script>

<style>
	.mengCengtu {
		display: none;
	}
	
	.w-100 {
		width: 100%;
	}
	
	body {
		position: relative;
	}
	
	/* 蒙层 */
	.mengCeng {
		position: fixed;
		top: 0;
		left: 0;
		opacity: 0.8;
		width: 100vw;
		height: 0vh;
		z-index: 999;
		background-color: #323232;
	}
</style>
